<div class="grid-component">
  @if (props.label) {
    <label tabindex="0" [innerHTML]="props.label"></label>
  }
  <div class="toolbar clearfix w-100">
    @if (showTemplates) {
      <mat-form-field class="col-12 col-lg-9">
        <mat-label>{{ label }}</mat-label>
        <mat-select
          [placeholder]="placeholder"
          [disabled]="disableTemplates || field.form.disabled"
          (selectionChange)="checkApplyTemplate($event)"
        >
          @if (firmTemplates && firmTemplates.length > 0) {
            <mat-optgroup label="Firm Templates">
              @for (tmplt of firmTemplates; track tmplt.id) {
                <mat-option [value]="tmplt">
                  {{ tmplt.name }}
                </mat-option>
              }
            </mat-optgroup>
          }
          @if (templates && templates.length > 0) {
            <mat-optgroup label="User Templates">
              @for (tmplt of templates; track tmplt.id) {
                <mat-option [value]="tmplt">
                  {{ tmplt.name }}
                </mat-option>
              }
            </mat-optgroup>
          }
        </mat-select>
        <mat-hint />
      </mat-form-field>
    }
    @if (fiveTwoNineSearch) {
      <app-five-two-nine-picker
        [form]="form"
        [program]="
          field.parent.parent.parent.model.ValidateProduct
            ?.InvestmentValidation_Program
        "
        [existingPlan]="field.parent.model?.Selected529PlansArray_PlanID"
        [clear]="clear529()"
        (selectedPlan)="handle529($event)"
      />
    }

    @if (canSearchInvestments && searchOptions) {
      <div class="fund-search-container">
        <app-fund-search
          #fundSearch
          class="search-box mb-3"
          [type]="props.searchType"
          [options]="searchOptions"
          [program]="program"
          [fiveTwoNinePlan]="selected529?.PlanId"
          [search529]="fiveTwoNineSearch"
          [parentField]="field"
          (fundSelected)="handleFund($event)"
        />
        @if (canUseFundLookupPopulateBtn) {
          <button
            mat-raised-button
            class="btn"
            type="button"
            color="accent"
            (click)="fundLookup()"
          >
            Fund Lookup Data
          </button>
        }
        @if (buttonOption && this.field['showButton']) {
          <button
            mat-button
            class="btn-primary"
            color="primary"
            type="button"
            [disabled]="field.form.disabled"
            (click)="add()"
          >
            <mat-icon class="me-2">add_circle</mat-icon>{{ buttonOption }}
          </button>
        }
      </div>
    }

    @if (
      !searchOptions &&
      this.field['showButton'] &&
      !hideDelete &&
      !field.form.disabled
    ) {
      <button
        mat-button
        class="btn btn-primary pull-right"
        color="primary"
        type="button"
        (click)="add()"
      >
        <mat-icon class="me-2">add_circle</mat-icon>Add
      </button>
    }
  </div>
  @if (this.field['showCsvFunctions']) {
    <div>
      <span class="pull-right">
        <button
          mat-button
          class="btn btn-primary pull-right"
          color="primary"
          type="button"
          (click)="downloadCsvTemplate($event)"
        >
          <mat-icon>download</mat-icon>Download CSV Template
        </button>
      </span>
      <span class="pull-right">
        <input
          #csvUpload
          type="file"
          class="file-input"
          (change)="onFileSelected($event)"
        />

        <span class="file-upload">
          @if (fileName) {
            <div class="upload-file-name mb-1">
              File selected: <strong class="ms-1 me-2">{{ fileName }}</strong>
              <button
                type="button"
                class="confirm-button"
                matTooltip="Confirm upload"
                (click)="completeCsvUpload()"
              >
                <mat-icon>check</mat-icon>
              </button>
              <button
                type="button"
                class="cancel-button me-2"
                matTooltip="Choose a different file"
                for="csvUpload"
                (click)="csvUpload.click()"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>
          } @else {
            <button
              mat-button
              class="btn btn-primary pull-right"
              color="primary"
              for="csvUpload"
              type="button"
              (click)="csvUpload.click()"
            >
              <mat-icon class="me-2">upload</mat-icon>Upload CSV/Excel
            </button>
          }
        </span>
      </span>
    </div>
  }

  @if (externalButtonOption && this.field['showExternalButton']) {
    <button
      mat-button
      class="mb-2 product-shelf-btn"
      color="primary"
      type="button"
      [disabled]="field.form.disabled"
      (click)="onLinkClick()"
    >
      <mat-icon class="me-2">search</mat-icon>{{ externalButtonOption }}
    </button>
  }

  @if (field.key === 'SelectedFunds') {
    <h5 class="w-100 pull-right">
      Investment Program: {{ investmentProgramLabel }}
    </h5>
  }

  @if (!loading && checkShowGrid()) {
    <div class="form-grid-container col-12">
      <kendo-grid
        #grid
        [kendoGridBinding]="model"
        [selectable]="{ enabled: false }"
        [navigable]="true"
        [scrollable]="true"
      >
        @for (column of columns; track column.key) {
          <kendo-grid-column
            [field]="column.key"
            [editable]="true"
            [hidden]="column.visuallyHidden || hideColumn(field, column, 0)"
            [attr.aria-label]="column.label"
          >
            <ng-template kendoGridHeaderTemplate>
              <div [ngClass]="{ 'has-help': column.help }">
                {{ column.label }}
                @if (column.help) {
                  <span
                    matTooltip="{{ props.help }}"
                    aria-label="help"
                    tabindex="0"
                    [matTooltipPosition]="'above'"
                    [matTooltipClass]="'rb-tooltip'"
                  >
                    <mat-icon class="col-1 help-icon"> help </mat-icon>
                  </span>
                }
              </div>
            </ng-template>
            <ng-template
              let-rowIndex="rowIndex"
              let-value="value"
              let-row="row"
              kendoGridCellTemplate
              k-grid-ignore-click
            >
              <formly-field
                k-grid-ignore-click
                [field]="getField(field, column, rowIndex)"
              />
              @if (checkHighlightRow(field, rowIndex)) {
                <span class="the-highlight"></span>
              }
            </ng-template>
          </kendo-grid-column>
        }
        @if (showDelete()) {
          <kendo-grid-column width="70">
            <ng-template
              let-rowIndex="rowIndex"
              let-value="value"
              let-row="row"
              kendoGridCellTemplate
            >
              <button
                type="button"
                mat-icon-button
                class="delete"
                matTooltip="Delete Entry"
                aria-label="Delete entry button"
                kendoGridFocusable
                (click)="remove(rowIndex, $event)"
              >
                <mat-icon>cancel</mat-icon>
              </button>
              @if (checkHighlightRow(field, rowIndex)) {
                <span class="the-highlight"></span>
              }
            </ng-template>
          </kendo-grid-column>
        }

        <ng-template kendoGridNoRecordsTemplate>{{ noRecords }}</ng-template>
      </kendo-grid>
    </div>
  }

  @if (this.field['showCalculator']) {
    <app-form-calculator
      [field]="field"
      [mode]="mode"
      [totalAmount]="amountAvailable"
      [totalInvestment]="amountAllocated"
      [percentLeft]="percentLeft"
    />
  }
</div>
<ngx-loading [show]="uploadingFile || fundLookupLoading" />
